import React from 'react';
import { connect } from 'react-redux';
import defer from 'lodash/defer';
import {
  Cookies,
} from '@resy/ui-kitchen';
import getQueryVariable from '../../../../../ui-kitchen/src/utils/getQueryVariable';
import { selectIsAuthenticated } from '../../../../../ui-kitchen/src/reducers/authTokenSlice';
import { selectIsGlobalDiningAccess } from '../../../../../ui-kitchen/src/reducers/userSlice';
import { setLocationPath } from '../../../../../ui-kitchen/src/utils/locationUtils';
import {
  FOLDER_NAME,
  FILE_NAME,
  CARD_TYPES,
  FILE_NAME_REFRESH,
} from './constants';
import {
  fetchS3JsonFile, scrollTo, isSectionHidden, isGDAUser,
} from '../AmexMarketingUtils/AmexUtils';
import {
  handleTaggingWithProps, isCreditSpecificUrl, isUserCardCreditSpecific, getCardType, getCardTypeWithUrl,
} from './AmexResyCreditDetails';
import { setResyCreditCardTypes } from '../../../../../ui-kitchen/src/reducers/amexEventsSlice';
import AmexHeader from '../AmexMarketingUtils/AmexHeader';
import AmexBanner from '../AmexMarketingUtils/AmexBanner';
import AmexLoading from '../AmexMarketingUtils/AmexLoading';
import AmexFAQs from '../AmexMarketingUtils/AmexFAQs';
import AmexTabbedCarousel from '../AmexMarketingUtils/AmexTabbedCarousel';
import AmexTabbedCarouselRefresh from '../AmexMarketingUtils/AmexTabbedCarouselRefresh';
import LayoutCreditRefresh from '../AmexMarketingUtils/AmexTabbedCarouselRefresh/LayoutCreditRefresh/LayoutCreditRefresh';
import AmexResyCreditCardSpecific from './AmexResyCreditCardSpecific';
import AmexNaaMgmComponent from '../AmexMarketingUtils/AmexNaaMgmComponent';
import AmexResyCreditEligibleVenues from '../AmexMarketingUtils/AmexResyCreditEligibleVenues';
import AmexResyCreditNAA from './AmexResyCreditNAA';
import AmexResyCreditMGM from './AmexResyCreditMGM';
import AmexHowItWorks from '../AmexMarketingUtils/AmexHowItWorks';
import AmexTerms from '../AmexMarketingUtils/AmexTerms';
import AmexResyCreditProps from './AmexResyCreditProps';
import './AmexResyCredit.scss';

import {
  CMT_COOKIE_NAME,
  GOLD_CARD,
} from '../AmexMarketingUtils/constants';

let hashTimeout = null;

class AmexResyCredit extends React.Component {
  static propTypes = AmexResyCreditProps;

  state = {
    contentData: {},
    hash: null,
    hideNAAState: false,
    hideMGMState: false,
    isPageReady: false,
  }

  componentDidMount() {
    const currentHash = (window.location.hash).replace('#', '');
    window.addEventListener('hashchange', this.handleHashChange, false);
    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
    } = this.props;
    this.fetchDataFile(baseRequestUrl, currentHash);
  }

  async componentDidUpdate(prevProps, prevState) {
    const { hash, contentData, isPageReady } = this.state;

    if (prevState.hash !== hash) {
      window.location.hash = hash;
      if (hash) {
        hashTimeout = setTimeout(() => {
          scrollTo(`#${hash}`);
        }, 1000);
      }
    }

    const {
      isAuthenticated, userDataInfo, isNonUS, $location,
    } = this.props;

    if (contentData
      && (prevProps.userDataInfo !== userDataInfo
        || prevProps.isAuthenticated !== isAuthenticated
        || prevProps.isNonUS !== isNonUS
        || prevState.contentData !== contentData)) {
      const isDisplayCardSpecific = this.getIsDisplayCardSpecific(isAuthenticated, userDataInfo, $location, contentData);
      this.isNAAMGMHidden(isNonUS, contentData, isDisplayCardSpecific);
      this.isCarouselOrCardSpecificHidden(userDataInfo, $location, contentData, isDisplayCardSpecific);
      if (!isPageReady) this.setPageStatusUpdate();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.handleHashChange, false);
    if (hashTimeout) clearTimeout(hashTimeout);
  }

  handleHashChange = () => {
    const currentLocationHash = (window.location.hash).replace('#', '');
    if (currentLocationHash && currentLocationHash !== '') {
      this.setState({ hash: currentLocationHash });
    }
  };

  fetchDataFile = async (baseRequestUrl, hash) => {
    const { dispatch } = this.props;

    // Try the refresh file first; fall back to the legacy file if it is unavailable.
    // This means once FILE_NAME is retired, no code change is needed here.
    const refreshData = await fetchS3JsonFile(baseRequestUrl, FOLDER_NAME, FILE_NAME_REFRESH, true);
    const contentData = refreshData
      ? { ...refreshData, is_resy_credit_2026_enabled: true }
      : await fetchS3JsonFile(baseRequestUrl, FOLDER_NAME, FILE_NAME, true);

    this.setState({ contentData, hash });
    const { amex_card_types: amexCardTypes } = contentData;
    dispatch(setResyCreditCardTypes(amexCardTypes));
  }

  handleTagging = (eventName, params) => {
    const { Analytics } = this.props;
    handleTaggingWithProps(eventName, Analytics, params);
  }

  getIsDisplayCardSpecific = (isAuthenticated, userDataInfo, $location, contentData) => {
    const { amex_card_types: amexCardTypes } = contentData;
    const displayCardSpecific = (Cookies.get(CMT_COOKIE_NAME) === GOLD_CARD) || isCreditSpecificUrl($location)
      || (isAuthenticated && isUserCardCreditSpecific(userDataInfo, amexCardTypes));

    return displayCardSpecific;
  }

  isNAAMGMHidden= (isNonUS, contentData, isDisplayCardSpecific) => {
    const { isUserLoggedInAsGDA } = this.props;
    const isGDA = isGDAUser(isUserLoggedInAsGDA, Cookies);

    let hideNAA = true;
    let hideMGM = true;

    if (isGDA) {
      hideNAA = isSectionHidden(contentData, 'naa') || isNonUS || isGDA;
      hideMGM = isSectionHidden(contentData, 'mgm') || isNonUS || !isGDA;
    } else {
      hideNAA = isSectionHidden(contentData, 'naa') || isNonUS || isDisplayCardSpecific;
      hideMGM = isSectionHidden(contentData, 'mgm') || isNonUS || !isDisplayCardSpecific;
    }

    this.setState({ hideNAAState: hideNAA, hideMGMState: hideMGM });
  }

  isCarouselOrCardSpecificHidden = (userDataInfo, $location, contentData, isDisplayCardSpecific) => {
    const { amex_card_types: amexCardTypes } = contentData;

    const {
      carousel: carouselConfig,
      card_specific: specificCardConfig,
    } = contentData;

    const hideCarousel = isSectionHidden(contentData, 'carousel') || carouselConfig?.sections?.length === 0 || isDisplayCardSpecific;
    const hideSpecificCard = isSectionHidden(contentData, 'card_specific') || specificCardConfig?.cards?.length === 0 || !isDisplayCardSpecific;

    const cardType = getCardType(window.location.pathname, userDataInfo, amexCardTypes);
    this.getTermsFAQsContent(cardType, contentData, amexCardTypes);

    this.setState({
      hideCarouselState: hideCarousel,
      hideSpecificCardState: hideSpecificCard,
      cardType,
    });
  }

  getTermsFAQsContent = (cardType, contentData) => {
    let faqsConfig = contentData?.faqs;
    if (cardType) {
      const faqFilteredArr = faqsConfig?.subsections.filter((item) => (item.card_types?.includes(cardType)));
      faqsConfig = {
        ...faqsConfig,
        subsections: faqFilteredArr,
      };

      const termsConfig = contentData?.terms;
      const updatedSubsections = termsConfig?.subsections?.map((itemTerm) => {
        if (itemTerm?.terms_type === 'credit') {
          itemTerm.sub_type = cardType;
        }
        return itemTerm;
      });
      this.setState({
        faqsConfig,
        termsConfig: {
          ...termsConfig,
          subsections: updatedSubsections,
        },
      });
    }
  }

  setPageStatusUpdate = () => this.setState({ isPageReady: true });

  render() {
    const {
      $location,
      $rootScope,
      $rootScope: {
        matchMedia,
      },
      $routeParams,
      Analytics,
      isAuthenticated,
      isNonUS,
      ResyAmexConfig: {
        baseRequestUrl,
      },
      loadNotifyModal,
      showAuthModal,
    } = this.props;

    const {
      contentData,
      hash,
      hideNAAState,
      hideMGMState,
      cardType,
      hideCarouselState,
      hideSpecificCardState,
      faqsConfig,
      termsConfig,
      isPageReady,
    } = this.state;

    if (Object.keys(contentData).length === 0) return <AmexLoading />;
    const {
      is_page_enabled: isPageEnabled,
      carousel: carouselConfig,
      card_specific: specificCardConfig,
      aws_folder_name: awsFolderName,
      is_sigma_enabled: isSigmaEnabled,
      q1_media_ads_utms: q1MediaAdsUtms,
      naa_for_media_enabled: naaForMediaEnabled = true,
      is_resy_credit_2026_enabled: isResyCredit2026Enabled = false,
    } = contentData;

    const isPlatinumCard = CARD_TYPES.AMEXPLATINUM === getCardTypeWithUrl(window.location.pathname);

    const isQ1MediaAdsEnabled = naaForMediaEnabled && q1MediaAdsUtms?.some(({ utm_campaign: campaign, utm_content: content }) => {
      const utmCampaign = getQueryVariable('utm_campaign') || '';
      const utmContent = getQueryVariable('utm_content') || '';
      return utmCampaign === campaign && utmContent === content;
    });

    if (!isPageEnabled || (isPlatinumCard && !isSigmaEnabled)) {
      // 404 error page
      setLocationPath('/404', () => defer(() => $rootScope.$apply()));
      return null;
    }

    const activeCard = carouselConfig?.sections.find((item) => item.type === cardType);
    const specificCard = specificCardConfig?.cards.find((item) => item.type === cardType);
    return (
      <section className="AmexResyCredit">
        <AmexHeader
          Analytics={Analytics}
          isAuthenticated={isAuthenticated}
          isNonUSLocation={isNonUS}
          $rootScope={$rootScope}
          $routeParams={$routeParams}
          handleTagging={this.handleTagging}
          $location={$location}
          matchMedia={matchMedia}
          resyHeaderConfig={contentData?.resy_header}
          tagConfig={contentData?.tagging}
        />
        {isResyCredit2026Enabled ? (
          <AmexBanner
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            bannerConfig={contentData?.banner}
            hasCopyOverlay
            matchMedia={matchMedia}
            bannerContext={{
              userCardType: cardType,
              isLoggedIn: !!isAuthenticated,
            }}
          />
        ) : (
          <AmexBanner
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            bannerConfig={contentData?.banner}
            isExtended
            matchMedia={matchMedia}
          />
        )}
        {!isResyCredit2026Enabled && !hideNAAState && isQ1MediaAdsEnabled && (
          <AmexNaaMgmComponent
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            matchMedia={matchMedia}
            sectionConfig={contentData?.naa}
            eventAnalytics={Analytics.event}
            isNAA
          />
        )}

        {isResyCredit2026Enabled && !hideCarouselState && (
          <AmexTabbedCarouselRefresh
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            carouselConfig={carouselConfig}
            hash={hash}
            matchMedia={matchMedia}
            Analytics={Analytics}
          />
        )}
        {!isResyCredit2026Enabled && !hideCarouselState && (
          <AmexTabbedCarousel
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            carouselConfig={carouselConfig}
            hash={hash}
            matchMedia={matchMedia}
            Analytics={Analytics}
            isPageReady={isPageReady}
            hasStickyHeader
          />
        )}
        {isResyCredit2026Enabled && !hideSpecificCardState && (
          <LayoutCreditRefresh
            awsFolderName={awsFolderName}
            Analytics={Analytics}
            baseRequestUrl={baseRequestUrl}
            specificCardContent={specificCard}
            content={activeCard?.content}
            tabHeading={activeCard?.title}
            tabThumbImage={activeCard?.thumb_image}
            matchMedia={matchMedia}
            isStandalone
            id={activeCard?.id}
          />
        )}
        {!isResyCredit2026Enabled && !hideSpecificCardState && (
          <AmexResyCreditCardSpecific
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            cardsConfig={specificCardConfig}
            cardName={cardType}
            matchMedia={matchMedia}
            eventAnalytics={Analytics.event}
          />
        )}
        {isResyCredit2026Enabled && !isSectionHidden(contentData, 'venues') && cardType && (
          <AmexResyCreditEligibleVenues
            $rootScope={$rootScope}
            $routeParams={$routeParams}
            Analytics={Analytics}
            content={contentData?.venues}
            loadNotifyModal={loadNotifyModal}
            matchMedia={matchMedia}
            flowName={cardType}
            showAuthModal={showAuthModal}
            isResySelector={contentData?.venues?.is_resy_selector_enabled}
          />
        )}
        {!isSectionHidden(contentData, 'how_it_works') && cardType && (
          <AmexHowItWorks
            iconPathPrefix={`${baseRequestUrl}ResyCredit/images/`}
            howItWorksConfig={contentData?.how_it_works}
            cardName={cardType}
            matchMedia={matchMedia}
            isResyCredit2026Enabled={isResyCredit2026Enabled}
          />
        )}
        {!isResyCredit2026Enabled && !hideNAAState && !isQ1MediaAdsEnabled && (
          <AmexNaaMgmComponent
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            matchMedia={matchMedia}
            sectionConfig={contentData?.naa}
            eventAnalytics={Analytics.event}
            isNAA
          />
        )}
        {isResyCredit2026Enabled && !hideNAAState && !isQ1MediaAdsEnabled && (
          <AmexResyCreditNAA
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            matchMedia={matchMedia}
            sectionConfig={contentData?.naa}
            eventAnalytics={Analytics.event}
          />
        )}
        {!isResyCredit2026Enabled && !hideMGMState && (
          <AmexNaaMgmComponent
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            matchMedia={matchMedia}
            sectionConfig={contentData?.mgm}
            eventAnalytics={Analytics.event}
          />
        )}
        {isResyCredit2026Enabled && !hideMGMState && (
          <AmexResyCreditMGM
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            sectionConfig={contentData?.mgm}
            eventAnalytics={Analytics.event}
          />
        )}
        {!isSectionHidden(contentData, 'faq') && faqsConfig && (
          <AmexFAQs
            faqsConfig={faqsConfig}
            eventAnalytics={Analytics.event}
            isResyCredit2026Enabled={isResyCredit2026Enabled}
            matchMedia={matchMedia}
          />
        )}

        {!isSectionHidden(contentData, 'terms') && cardType && (
          <AmexTerms
            baseRequestUrl={baseRequestUrl}
            hash={hash}
            termsConfig={termsConfig}
            eventAnalytics={Analytics.event}
          />
        )}
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: selectIsAuthenticated(state),
  isNonUS: state.ipdata?.isNonUS,
  userDataInfo: state.user?.userData,
  isUserLoggedInAsGDA: selectIsGlobalDiningAccess(state),
});

AmexResyCredit.displayName = 'AmexResyCredit';
export { AmexResyCredit as ComponentAmexResyCreditUnderTest, mapStateToProps };
export default connect(mapStateToProps)(AmexResyCredit);
